import { useState } from 'react'

import { t } from 'i18next'

import useModal from '~/hooks/useModal'

import ThumbVideoWithPreview from '../ThumbVideo'

import * as S from './styles'

interface Props {
  url: string
  title?: string
  size?: 'tiny' | 'small' | 'medium'
}

/**
 * Componente que renderiza um thumb via url e permite dar um zoom no vídeo
 * abrindo num de um modal
 */

const ThumbVideoZoomable = ({
  url,
  title = t('c:actions.clickToZoom'),
  size = 'medium'
}: Props) => {
  const [show, setShow] = useState(false)

  const [Modal, , , setIsShowing] = useModal()

  const handleCloseModal = () => {
    setIsShowing(false)
    setShow(false)
  }

  return (
    <>
      <S.Asset
        onClick={() => setShow(true)}
        className="videoWrapper"
        data-size={size}
      >
        <ThumbVideoWithPreview url={url} title={title} />
      </S.Asset>

      {show && (
        <Modal isOpen={!!show} onClose={handleCloseModal} maxWidth="auto">
          <video src={url} autoPlay controls />
        </Modal>
      )}
    </>
  )
}

export default ThumbVideoZoomable
